import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../common/global-variables';

@Component({
    template: `
    <div class="login-wrapper">
      <form class="login">
            <label class="title">
                <span *ngIf="isCloudSite" class="title-cloud">{{'header.title' | translate}}&#174;</span>
                <span *ngIf="!isCloudSite" class="title-onprem">{{'header.title' | translate}}&#174;</span>
            </label>
          <div class="login-group" *ngIf="authService.isLogoutInProgress">
                {{ 'auth.logoutProgress' | translate }}
          </div>
          <div class="login-group" *ngIf="authService.isLogoutComplete">
                {{ 'auth.logoutComplete' | translate }}
          </div>
      </form>
    </div>`
})
export class LogoutComponent {
    public isCloudSite: boolean = false; // TODO: use context API to get this value
    public message: string;
    constructor(public authService: AuthService,
                public router: Router,
                translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/logout.component.ts